class ShortVariant extends HTMLElement  {
  constructor(){
    super();
    this.form = this.querySelector('form');
    this.variantInputs = this.querySelectorAll('.be-awara-collection[data-option-index] .swatch-element label[data-available-variant-product-card=true]');
    this.addMessage =   document.getElementById('cart-new-success-message');
    this.init();
  }
  init(){
    this.variantInputs.forEach(item =>{
      item.addEventListener('click',()=>{
        document.body.classList.add('loading');
        let variantId = item.dataset.variantId;
        if(variantId){
          this.addToCart(variantId,item);
        }else{
          document.body.classList.remove('loading');
        }
      })
    });
    
  }
  addToCart(variantId,item){
   
    let formData = {
 'items': [{
  'id': variantId,
  'quantity': 1
  }]
};
 
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  if(response.status == '200'){
     this.addMessage.style.right = 0 +'%';
     return response.json(); 
  }
}).
  then(data =>{
      fetch('/cart.js').
    then(r => r.json()).
    then(s => {
      let cartCounter = document.querySelector('#CartCount');
         if(cartCounter){
           cartCounter.innerHTML = s.item_count;
         }
    });
  })
.catch((error) => {
  console.error('Error:', error);
})
.finally(()=>{
      document.body.classList.remove('loading');
       setTimeout(()=>{
          this.addMessage.style.right = -100 +'%';
       },1500);
})

  }
}
customElements.define("short-variants", ShortVariant);